export var UserRoles = function (UserRoles) {
  UserRoles["MANAGER"] = "ROLE-G-SC-CCUI-Manager";
  UserRoles["AGENT"] = "ROLE-G-SC-CCUI-Agent";
  UserRoles["PROMO_ADMIN"] = "ROLE-G-SC-CCUI-UAT-PROMOADMIN";
  UserRoles["PROMO_ADMIN_PROD"] = "ROLE-G-SC-CCUI-PROD-PROMOADMIN";
  return UserRoles;
}({});
export var UserAccessLevels = function (UserAccessLevels) {
  UserAccessLevels["SUPER"] = "SUPER";
  UserAccessLevels["BOOKER"] = "BOOKER";
  UserAccessLevels["SELF"] = "SELF";
  UserAccessLevels["STAYER"] = "STAYER";
  UserAccessLevels["BUSINESS_PAY_MANAGER"] = "BUSINESS_PAY_MANAGER";
  UserAccessLevels["BUSINESS_PAY_USER"] = "BUSINESS_PAY_USER";
  return UserAccessLevels;
}({});